module.exports = __webpack_public_path__ + "static/media/a8.8033f89.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caoxi/a8.mp3
// module id = WR9A
// module chunks = 0